import { Icon } from './Icon';

/**
 * Narrows the rows already on screen. It never asks the API for more, so the
 * placeholder says "this page" rather than promising a search of everything.
 */
export function SearchBox({
  label,
  placeholder,
  value,
  onChange,
}: {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
}): React.JSX.Element {
  return (
    <span className="search">
      <Icon name="search" size={16} />
      <input
        type="search"
        aria-label={label}
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </span>
  );
}
